import idVerificationActions, {
    errorMessageTypes,
    stepTypes,
    takePhoto,
    changeStep,
} from '../../actions/IdVerificationActions';

import navigationService from '../../services/NavigationService';
import liveSessioner from '../../services/livesession/LiveSessioner';

import { checkSimilarity, uploadPhoto } from '../../services/idverification/IdVerificationApi';
import idVerificationService from '../../services/idverification/IdVerificationService';
import storeManager from '../../store/StoreManager';

const captureDeviceStepSelector = {
    onPhotoCapturedCallback(photo) {
        storeManager.dispatch(takePhoto());
        uploadPhoto(photo);
    },

    onNextCallback(currentStep, idverification) {
        if (currentStep === stepTypes.PHOTO) {
            if (idVerificationService.needsIdCard(false)) {
                storeManager.dispatch(changeStep(stepTypes.ID_CARD));
            } else {
                navigationService.navigateToTestOverview();
                if (idVerificationService.isRequestPhotoRetakeVerificationStatus(idverification)) {
                    storeManager.dispatch(idVerificationActions.setPhotoRetakeCompleted(true));
                }
            }
        } else {
            storeManager.dispatch(changeStep(stepTypes.SIMILARITY));
            checkSimilarity();
            navigationService.navigateToTestOverview();
        }
    },

    selectProps({ idverification }) {
        const {
            currentStep,
            verificationStatus,
        } = idverification;

        const stream = liveSessioner.getGrantedStream();

        return {
            checkpointPending: verificationStatus === errorMessageTypes.loading,
            currentStep,
            isHardwareAccessGranted: stream != null,
            onNext: this.onNextCallback.bind(this, currentStep, idverification),
            onPhotoCaptured: this.onPhotoCapturedCallback,
            stream,
        };
    },
};

export default captureDeviceStepSelector;
